import React from 'react';
import { Link } from 'react-router-dom';

const RegisterPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-4xl font-bold text-white">Create your account</h2>
        <p className="mt-2 text-lg text-white">
          Join and start earning HEP coins for your work
        </p>
      </div>

      <div className="text-center py-8">
        <p className="text-gray-500">Registration form coming soon...</p>
        <p className="text-sm text-gray-400 mt-2">
          For now, please use the test accounts provided on the login page.
        </p>
      </div>

      <div className="text-center border-t pt-6">
        <p className="text-sm text-gray-600">
          Already have an account?{' '}
          <Link
            to="/login"
            className="font-medium text-primary-600 hover:text-primary-500"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;